import React from 'react'
import Draggabilly from 'draggabilly'
import AnnotationColorHelper from './AnnotationColorHelper'

class AnnotationBubble extends React.Component {
  constructor(props) {
    super(props)
    this.bubble = React.createRef();
    this.toggleAnnotation = this.toggleAnnotation.bind(this)
  }

  allAnnotations(){
    this.props.klass.annotations
  }

  bindCustomListeners() {
    let draggie = this.setUpDraggable(this.bubble.current);
    draggie.on('staticClick', this.toggleAnnotation)
    draggie.on('dragStart', this.closeAnno.bind(this))
    draggie.on('dragEnd', this.updatePosition.bind(this, draggie))
  }

  componentDidMount() {
    this.bindCustomListeners();
  }

  closeAnno() {
    this.props.klass.closeCurrentAnnotation()
  }

  updatePosition(ele, pointer) {
    let x = ( ele.position.x / $('.js-annotation-boundry').width()) * 100
    let y = ( ele.position.y / $('.js-annotation-boundry').height()) * 100
    this.props.klass.updateAnnotationPosition(this.props.annotation, {x: x, y: y})
  }

  setUpDraggable(ele) {
    return new Draggabilly(ele, {containment: '.js-annotation-boundry'});
  }

  toggleAnnotation(){
    if (this.props.klass.currentAnnotation) {
      this.props.klass.closeCurrentAnnotation()
    } else {
      this.props.klass.showAnnotation(this.props.annotation.id)
    }
  }

  render() {
    const ann = this.props.annotation;
    const style = {
      position: 'absolute',
      left: `${ann.percent_x}%`,
      top: `${ann.percent_y}%`,
    };
    const approved = ann.resolved == true ? 'approved' : '';
    const color = AnnotationColorHelper(this.props.annotation)
    return (
      <div ref={this.bubble} className={`annotation annotation-${ann.source} ${approved} ${color}`} data-id={ann.id} data-x={ann.percent_x} data-y={ann.percent_y} style={style}>{this.props.index}</div>
    )
  }
}

export default AnnotationBubble
